import { render, staticRenderFns } from "./MaterialRadioList.vue?vue&type=template&id=5f0245f2&scoped=true&"
import script from "./MaterialRadioList.vue?vue&type=script&lang=js&"
export * from "./MaterialRadioList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRadioList.vue?vue&type=style&index=0&id=5f0245f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0245f2",
  null
  
)

export default component.exports